<template>
  <ion-page>
    <ion-content>
      <LargeNavbar
        @backButton="backButton"
        show-back-button
        :title="t('profile.myAccountTitle')"
        :show-actions="false"
      />
      <div class="d-flex w-100 justify-space-center">
        <div class="content w-100 ion-padding">
          <Form
            form-name="login"
            id="loginForm"
            :validation-schema="schemaSettingEdit"
            @submit="handleSettingSubmit(true)"
          >
            <ion-row>
              <ion-col size="12">
                <h4 class="h4 text-align-left mt-8 text-color-placeholder">
                  {{ t('profile.setting.title') }}
                </h4>
                <ion-label class="mt-16">{{ t('profile.setting.description') }}</ion-label>
              </ion-col>
              <ion-col size="12" class="mt-32">
                <CustomInput
                  form-name="profile"
                  type="text"
                  :value="languageSelected"
                  v-model="languageSelected"
                  input-type="select"
                  :label="t('profile.labels.language')"
                  name="language"
                  class-name="custom-field"
                  :icon="homeOutline"
                  :options="languageOptions"
                  item-id="id"
                  item-name="label"
                />
              </ion-col>
              <ion-col size="12">
                <ion-button
                  expand="block"
                  color="primary"
                  fill="solid"
                  class="text-weight-bold"
                  type="submit"
                  >{{ t('actions.saveChanges') }}
                </ion-button>
              </ion-col>
            </ion-row>
          </Form>

          <div class="b-grey mt-lg mb-lg"></div>
          <div>
            <ion-row>
              <ion-col size="12">
                <h4 class="h4 text-align-left mt-8 text-color-placeholder">
                  {{ t('profile.setting.notifications') }}
                </h4>
              </ion-col>

              <ion-col size="12">
                <div class="d-flex ion-padding-bottom align-center justify-space-between">
                  <p class="font-sm">
                    {{ t('profile.setting.notificationsDescription') }}
                  </p>
                  <ion-toggle
                    v-model="pushNotifications"
                    :checked="pushNotifications"
                    @click="handleSettingSubmit()"
                  ></ion-toggle>
                </div>
              </ion-col>
            </ion-row>
          </div>

          <!-- Eliminar cuenta -->
          <div class="b-grey mt-lg mb-lg"></div>
          <div>
            <DeleteAccountSection />
          </div>
          <!-- Eliminar cuenta -->
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>
<script setup lang="ts">
  import { IonContent, IonPage, IonRow, IonCol, IonLabel, IonButton, IonToggle } from '@ionic/vue';
  import LargeNavbar from '@/components/LargeNavbar.vue';
  import { useI18n } from 'vue-i18n';
  import router from '@/router';
  import { useProfile } from '@/composables/useProfile';
  import { homeOutline } from 'ionicons/icons';
  import CustomInput from '@/components/shared/form/CustomInput.vue';
  import { useLanguages } from '@/utils/constants/general-constants';
  import { Form } from 'vee-validate';
  import { useSchemas } from '@/composables/useSchemas';
  import DeleteAccountSection from '@/components/profile/delete-account/DeleteAccountSection.vue';

  const { schemaSettingEdit } = useSchemas();
  const { t } = useI18n();
  const { languageSelected, pushNotifications, handlePutSetting } = useProfile();

  const languageOptions = useLanguages();

  const backButton = () => {
    router.back();
  };

  const handleSettingSubmit = (saveLanguage?: boolean) => {
    const notifications = saveLanguage ? pushNotifications.value : !pushNotifications.value;
    handlePutSetting(languageSelected.value, notifications);
  };
</script>
<style scoped lang="scss">
  ion-button {
    height: 36px;
  }

  ion-modal {
    --border-radius: 25px;
    --background: var(--ion-color-body);
  }

  ion-content {
    --border-radius: 25px;
    --background: white;
  }
</style>
